<template>
  <div class="py-5 md:px-5">
    <PageHeader class="container" title="Depots">
      <router-link :to="{ name: 'DepotCreate' }" class="btn btn-primary">
        Add Depot
      </router-link>
    </PageHeader>

    <div class="container">
      <Loading v-if="loading" />

      <div class="card" v-else>
        <!-- No Results -->
        <div v-if="depots.meta.total < 1" class="py-12 text-center">
          <p class="mb-8 text-lg font-bold">
            No depots have been added yet.
          </p> 
          <router-link :to="{ name: 'DepotCreate' }" class="btn btn-secondary">
            Add a Depot
          </router-link>
        </div>

        <!-- Results -->
        <div v-else>
          <!-- Table -->
          <data-table :items="depots.data" 
            :keys="[
              { name: 'Name', slug: 'name', class: 'font-bold' }
            ]">
            <template #actions="{ item }">
              <router-link :to="{ name: 'DepotEdit', params: { id: item.id } }" class="btn btn-sm btn-secondary">
                Edit
              </router-link>
            </template>
          </data-table>
          <!-- Pagination -->
          <Pagination class="rounded-b-lg" :total="depots.meta.total" :per-page="depots.meta.per_page" :current-page="depots.meta.current_page" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DepotList',

  metaInfo: {
    title: 'Depots'
  },

  async created () {
    await this.getDepots()
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      depots: {},
      loading: true,
      submitting: false
    }
  },

  methods: {
    async getDepots () {
      try {
        this.loading = true
        const { data } = await this.$api.get(`account/${this.$route.params.account}/depots`, {
          params: {
            page: this.$route.query.page || 1
          }
        })
        this.depots = data.depots
        this.loading = false
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      }
    },
    
    async syncDepots () {
      try {
        this.submitting = true
        await this.$api.put(`account/${this.$route.params.account}/depots`)
        this.getDepots()
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.submitting = false
      }
    }
  },

  watch: {
    '$route.query': {
      handler (newVal, oldVal) {
        this.getDepots()
      },
      deep: true
    }
  }
}
</script>